<div [id]="title + '-chart'" class="chart-gauge" [class]="variant"></div>
